export { default as Form } from 'accounts/components/form/AccountForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/form/index.js